import { render, staticRenderFns } from "./todoRead.vue?vue&type=template&id=75606ca1&scoped=true&"
import script from "./todoRead.vue?vue&type=script&lang=js&"
export * from "./todoRead.vue?vue&type=script&lang=js&"
import style0 from "./todoRead.vue?vue&type=style&index=0&id=75606ca1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75606ca1",
  null
  
)

export default component.exports